import { PROVIDER_PRIMARY_CARE_TEMPLATE_ID } from 'lib/constants';
import { LocationItem, SpecialtyItem } from '../../../types/provider-items';
import { hasPrimaryCareLocation } from './has-primary-care-location';

// Return a list of public-facing provider specialties, applying business logic
export const getUserFacingProviderSpecialties = (
  specialties: SpecialtyItem[] | undefined,
  locations: LocationItem[] | undefined
): SpecialtyItem[] => {
  const validSpecialties: SpecialtyItem[] = specialties ?? [];

  return validSpecialties.filter((specialty) => {
    if (specialty.id === PROVIDER_PRIMARY_CARE_TEMPLATE_ID) {
      return hasPrimaryCareLocation(locations);
    }

    return true; // keep all other specialties
  });
};
